import GenericVideoDialog from "./GeneralVideoDialog";
import React, {Component} from "react";
import {inject, observer} from "mobx-react";
import {AskToJoinStudentDialogId} from "./VideoChat";

@inject('videoChatStore')
@observer
export class AskToJoinStudentDialog extends Component {
    render() {
        const {isOpen, closeDialog, handleCancel, handleClose, handleAccept, videoChatStore} = this.props;
        return <GenericVideoDialog dialogId={AskToJoinStudentDialogId} isOpen={isOpen} onClose={closeDialog}
                                   titleKey={'video.chat.student.teacher.waiting.title'}
                                   textKey={'video.chat.student.teacher.waiting.text'} itemName={videoChatStore.peerUser?.name}
                                   buttonKey={'joinVideoLesson'}
                                   handleCancel={handleCancel}
                                   handleClose={handleClose}
                                   handleAccept={handleAccept}/>
    }
}